import {apiClient} from "../../../../lib/api-client";
import {FileGetUploadUrlResult} from "../types/FileGetUploadUrlResult";

export async function apiGetUploadUrl(fileName: string): Promise<FileGetUploadUrlResult> {
	try {
		return await apiClient.post("document/upload-url", { fileName: fileName });
	}
	catch (error) {
		return {
			isSuccess: false,
			errorMessage: "Error when generating upload URL: " + error
		};
	}
}
